/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { Button } from "react-bootstrap";
import styled from "styled-components";

export const Section = styled.section`
  background-image: url(${(props) => props?.bgImg});
  background-color: #cccccc;
  background-position: center;
  background-repeat: no-repeat;
  // background-size: contain;
  background-size: 100% 100%;
  height: 100vh;
`;
interface GButtonProps {
  bgColor?: string;
  textColor?: string;
  hoverBgColor?: string;
  hoverTextColor?: string;
}

export const GButton = styled(Button) <GButtonProps>`
  display: inline-block;
  padding: 24px 32px;
  border: 0;
  text-decoration: none;
  border-radius: 15px;
  background-color: ${({ bgColor }) => bgColor ?? "rgba(255, 255, 255, 0.5)"};
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(30px);
  color: ${({ textColor }) => textColor ?? "rgba(255, 255, 255, 0.8)"};
  font-size: 14px;
  letter-spacing: 2px;
  cursor: pointer;
  text-transform: uppercase;

  &:hover {
    color: ${({ hoverTextColor }) => hoverTextColor ?? "rgb(255, 255, 255)"};
    background-color: ${({ hoverBgColor }) =>
    hoverBgColor ?? "rgba(255, 255, 255, 0.7)"};
  }
`;

export const Heading = styled.h1`
  text-shadow: 2px 2px #000;
`;

export const Description = styled.p`
  color: #fff !important;
  font-size: 24px;
  text-shadow: 2px 2px #000;
  font-weight: 700 !important;
`;
